<div class="wrapper-modal banners">
  <form [formGroup]="createOrEditBannerForm" (ngSubmit)="submitCreateOrEditBannerForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">{{bannerForEdit ? 'Izmeni baner' : 'Kreiraj novi baner'}}</span>
    </div>
    <div class="content-modal">
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>Izaberite status</span>
        </div>
        <div class="wrapper-custom-radiobutton">
          <label>
            <input type="radio" formControlName="active" [value]="true">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Aktivan</span>
            </div>
          </label>
          <label>
            <input type="radio" formControlName="active" [value]="false">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Neaktivan</span>
            </div>
          </label>
        </div>
      </div>
      <div *ngIf="activeTab === BannerTypeEnum.landing && createOrEditBannerForm.controls.type.value === 'A'" class="grid__m-6">
        <div class="wrapper-input">
          <span class="label-input">Naziv</span>
          <div class="zc-input">
            <input type="text" formControlName="name">
          </div>
          <span class="error-message">{{createOrEditBannerForm.controls.name | formControlErrorMessages: null : formTriedToSubmit}}</span>
        </div>
      </div>
      <div *ngIf="activeTab === BannerTypeEnum.landing && createOrEditBannerForm.controls.type.value === 'A'" class="grid__m-6">
        <div class="wrapper-input">
          <span class="label-input">Opis</span>
          <div class="zc-input">
            <textarea type="text" formControlName="description"></textarea>
          </div>
          <span class="error-message">{{createOrEditBannerForm.controls.description | formControlErrorMessages: null : formTriedToSubmit}}</span>
        </div>
      </div>
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>Ubacite sliku banera</span>
        </div>
        <div class="wrapper-custom-gallery banners">
          <div *ngIf="!imageUrl" class="header-custom-gallery">
            <div class="wrapper-btn-gallery">
              <div class="file-input">
                <label class="file-input__label2">
                  <span>Dodaj Sliku</span>
                  <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event)"/>
                </label>
              </div>
            </div>
            <span class="error-message">{{createOrEditBannerForm.controls.image | formControlErrorMessages: null : formTriedToSubmit}}</span>
          </div>
          <div *ngIf="imageUrl" class="content-custom-gallery-banner">
            <div class="wrapper-gallery-image-banner">
              <img [src]="imageUrl" alt="banner-image">
              <div class="overlay-delete" (click)="removeFile()">
                <i class="fa-solid fa-xmark"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>Izaberite tip linka</span>
        </div>
        <div class="wrapper-custom-radiobutton">
          <label>
            <input type="radio" formControlName="link_type" [value]="'company'">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Profil kompanije</span>
            </div>
          </label>
          <label>
            <input type="radio" formControlName="link_type" [value]="'category'">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Kategorija</span>
            </div>
          </label>
          <label>
            <input type="radio" formControlName="link_type" [value]="'external'">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Externi link</span>
            </div>
          </label>
        </div>
      </div>
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>{{createOrEditBannerForm.get('link_type')?.value === 'company' ? 'Unesite profil kompanije' : 'Dodajte link'}}</span>
        </div>
        <div class="wrapper-input">
          <div class="zc-input">
            <input type="text" placeholder="Unesite naziv" [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="searchTerm" (ngModelChange)="autocompleteSubject.next($event)">
          </div>
          <div class="wrapper-dropdown-link">
            <div class="dropdown-link" *ngIf="autocompleteLinkSuggestions.length">
              <div class="item-dropdown-link" *ngFor="let suggestion of autocompleteLinkSuggestions" (click)="onSelectSuggestionLink(suggestion)"><span>{{suggestion.name}}</span></div>
            </div>
          </div>
          <span class="error-message">{{createOrEditBannerForm.controls.link | formControlErrorMessages: 'Unesite validan link' : formTriedToSubmit}}</span>
        </div>
      </div>
      <div *ngIf="activeTab === BannerTypeEnum.landing" class="xs-mb-20">
        <div class="label-banner">
          <span>Izaberite grupu banera</span>
        </div>
        <div class="wrapper-custom-radiobutton">
          <label *ngFor="let bannerPosition of bannerPositionArray; index as i" (click)="changeBannerType(i)">
            <input type="radio" formControlName="type" [value]="bannerPosition.value">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>{{bannerPosition.name}}</span>
            </div>
          </label>
        </div>
      </div>
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>Izaberite poziciju banera</span>
        </div>
        <div class="wrapper-custom-radiobutton">
          <label *ngFor="let bannerPosition of activeTab === BannerTypeEnum.application ? bannerPositionArray : landingBannerPositionArray">
            <input type="radio" formControlName="position" [value]="bannerPosition.value">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>{{bannerPosition.name}}</span>
            </div>
          </label>
        </div>
      </div>
      <gr-dropdown-reactive-form
        *ngIf="activeTab === BannerTypeEnum.landing "
        [items]="DurationOfBanner"
        [propIdentifier]="'value'"
        [dropdownLabel]="'Vreme trajanje banera'"
        [placeholder]="'Izaberite vreme trajanja bannera'"
        [formControl]="createOrEditBannerForm.controls.time | formControl"
        [formTriedToSubmit]="formTriedToSubmit"
      ></gr-dropdown-reactive-form>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>{{bannerForEdit ? 'Izmeni' : 'Dodaj'}}</span></button>
    </div>
  </form>
</div>


